import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "components/shared/ThemeProvider";

const ThemeToggle = ({
    variant = "outline-light",
    size = "sm",
    className = "",
}) => {
    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <Button
            variant={variant}
            size={size}
            onClick={toggleTheme}
            className={`d-flex align-items-center ${className}`}
            title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
        >
            <FontAwesomeIcon
                icon={isDarkMode ? faSun : faMoon}
                className="me-1"
            />
            <span className={"d-inline"}>{isDarkMode ? "Light" : "Dark"}</span>
        </Button>
    );
};

export default ThemeToggle;
